<template>
  <div class="header" :class="{ 'home-header': path == '/' || path == '/index' }">
    <div class="container">
      <!-- v-if="$route.name!='index' " -->
      <div class="logo" @click="goHome">
        <img src="@/assets/images/logo.svg" alt="">
      </div>
      <div class="nav">
        <TopNav />
      </div>

      <div class="header-right">
        <div class="search-btn" @click="goSearch">
          <span class="iconfont icon-search"></span>
        </div>
        <div class="user-btn" @click="userPop" ref="userBtn" :style="{ 'background-image': `url(${userInfo && userInfo.id ? userPic : ''}),url(${userInfo && userInfo.id ? touxiang : ''})` }">
          <span class="iconfont icon-renwu" v-if="!userInfo || !userInfo.id"></span>
          <el-dropdown trigger="click" v-else>
            <div class="avatar flex jc">
              <div class="default-img" v-if="!userInfo.cover_img"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <pop-user />
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import whiteLogo from '../assets/images/logo-white.svg'
import logo from '../assets/images/logo.svg'
import TopNav from '@/components/topnav.vue'
import PopUser from '../pages/popUser.vue'
import { mapMutations, mapState } from 'vuex'
import touxiang from '../assets/images/defaultImg.jpg';
import { encrypt } from '../utils/sm4Util'
export default {
  name: 'Header',
  components: {
    TopNav,
    PopUser,
  },
  props: {
    path: String
  },
  data() {
    return {
      whiteLogo, logo,
      showUser: false,
      showpath: '',
      touxiang
    }
  },
  computed: {
    ...mapState({ userInfo: 'userInfo', menu: state => state.UserRightMenu }),
    userPic() {
      return this.userInfo.cover_img ? this.userInfo.showpath + this.userInfo.cover_img : ''
    },
  },
  async mounted() {
    if (!this.userInfo || !this.userInfo.id) {
      await this.getUserInfo()
    }
    this.initPage()
  },
  methods: {
    ...mapMutations(["updateUserInfo", "getUserInfo", "updateList"]),

    initPage() {
      if (!this.userInfo) return;
      if (!this.userInfo.ip || this.userInfo.id != window.ip) {
        this.userInfo.ip = window.ip
      }
      this.updateUserInfo(this.userInfo);//更新全局状态
      this.getHeadImg();
    },
    goHome(e) {
      this.$router.push("/index")
    },
    goSearch() {
      if (this.$route.name == "search") {
        return;
      }
      this.$router.push({
        name: "search",
        query: {
          keyword: this.keyword
        }
      })
      setTimeout(() => {
        this.keyword = ''
      }, 300);
    },

    userPop() {
      if (this.userInfo && this.userInfo.id) {
        this.showUser = !this.showUser;
        if (this.userInfo.ip != window.ip && window.ip) {
          let userInfo = {
            ...this.userInfo,
            ip: window.ip
          }
          this.updateUserInfo(userInfo)
        }
        this.getMenuList()
      } else {
        if (this.$route.path == '/login' || this.$route.path == '/register') { return; }
        let link = this.$router.resolve({ path: "/login" })
        window.open(link.href, '_blank');
      }
    },

    hidePop() {
      this.showUser = false;
    },

    async getMenuList() {
      let res = await this.$api.userApi.getRightCount({
        user_id: this.userInfo.id
      });
      this.menu.map(t => {
        if (t.name == "授权资源") {
          // t.count = this.userInfo.show_ids;
          t.count = res.total;
        }
        if (t.name == "我的点赞") {
          t.count = res.data.likeCount;
        }
        if (t.name == "我的收藏") {
          t.count = res.data.collectCount;
        }
        if (t.name == "下载记录") {
          t.count = res.data.downloadCount;
        }
      });
      this.updateList("UserRightMenu", this.menu)
    },


    getHeadImg() {
      if (!this.userInfo && !this.userInfo.phone && !this.userInfo.openid) return;
      let params = {
        phone: this.userInfo.phone || encrypt(this.userInfo.openid)
      }
      this.$api.userApi.getHeadImg(params).then(res => {
        let newInfo;
        if (res.showpath) {
          newInfo = {
            ...this.userInfo,
            showpath: res.showpath
          }
          this.updateUserInfo(newInfo);
        }
        if (res.data && res.data.cover_img) {
          let userPic = res.data.cover_img;
          newInfo = {
            ...this.userInfo,
            userPic: userPic,
          }
          this.updateUserInfo(newInfo);
          this.$utils.setCookie("login", JSON.stringify(newInfo), 30)
        }
      })
    },

  },
}
</script>